module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/sign.js
// module id = 840
// module chunks = 1